import { AutoCompleteDto } from 'apiAuto/backend/schemas/AutoCompleteDto';
import { SearchLogic } from 'enums/searchLogic';
import { IExclusionLogicSelectItem } from 'interfaces/IExclusionLogicSelectItem';

export default class Accessory {
	public id: string = '';
	public name: string = '';
	public logic: SearchLogic = SearchLogic.Include;

	public constructor(input?: AutoCompleteDto) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapToSelectItem(): IExclusionLogicSelectItem {
		return {
			id: this.id,
			name: this.name,
			logic: this.logic,
		};
	}

	private mapFromApi(input: AutoCompleteDto): void {
		this.id = input.id;
		this.name = input.description;
		this.logic = SearchLogic.Include;
	}
}
